module.exports = __webpack_public_path__ + "static/assets/97dc9515c61745db45f30b5966a2e045.png";